import React from "react";
import * as RadixTooltip from "@radix-ui/react-tooltip";
import { TooltipContent, TooltipArrow } from "./styled";

export interface ITooltipComponentProps {
    tooltip: React.ReactNode;
    delayDuration?: number;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    tooltipSide?: RadixTooltip.TooltipContentProps["side"];
}

const Tooltip: React.FC<ITooltipComponentProps> = ({
    tooltip,
    delayDuration = 700,
    open,
    onOpenChange,
    tooltipSide,
    children
}) => {
    return (
        <RadixTooltip.Provider delayDuration={delayDuration}>
            <RadixTooltip.Root open={open} onOpenChange={onOpenChange}>
                <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
                <RadixTooltip.Portal>
                    <TooltipContent side={tooltipSide} sideOffset={5}>
                        {tooltip}
                        <TooltipArrow />
                    </TooltipContent>
                </RadixTooltip.Portal>
            </RadixTooltip.Root>
        </RadixTooltip.Provider>
    );
};

export default Tooltip;
